import React from 'react';
import { Link } from 'react-router-dom';
import { company, profile } from '../data';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="page-wrap site-footer__grid">
        <div className="site-footer__intro">
          <span className="site-footer__serial">PSHR / END NOTE</span>
          <Link className="brand brand--footer" to="/" data-cursor-label="HOME">
            <span className="brand__mark" aria-hidden="true">PSHR</span>
            <span className="brand__copy"><span>{profile.shortName}</span><small>Field notes / 26</small></span>
          </Link>
          <p>{profile.name} is the founder behind {company.legalName}, an independent product engineering practice for AI, SaaS, web, and mobile work.</p>
        </div>

        <div className="site-footer__column">
          <p className="eyebrow">Explore</p>
          <Link to="/about">About</Link>
          <Link to="/work">Selected work</Link>
          <Link to="/company">PSHR INNOVEX</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="site-footer__column">
          <p className="eyebrow">Direct</p>
          <a href={`mailto:${profile.email}`}>{profile.email}</a>
          <a href={profile.phoneHref}>{profile.phone}</a>
          <span>{profile.location}</span>
        </div>

        <div className="site-footer__column">
          <p className="eyebrow">Elsewhere</p>
          <a href={profile.social.linkedin} target="_blank" rel="me noopener noreferrer">LinkedIn <span aria-hidden="true">↗</span></a>
          <a href={profile.social.github} target="_blank" rel="noopener noreferrer">GitHub <span aria-hidden="true">↗</span></a>
          <a href={profile.social.instagram} target="_blank" rel="me noopener noreferrer">Instagram <span aria-hidden="true">↗</span></a>
        </div>
      </div>
      <div className="page-wrap site-footer__bottom">
        <span>© {new Date().getFullYear()} {profile.name}. All rights reserved.</span>
        <a href={`mailto:${profile.email}`} data-cursor-label="EMAIL">
          Let’s build the next useful thing <span aria-hidden="true">↗</span>
        </a>
      </div>
    </footer>
  );
}
